<template>
    <div>
        <div id="turnstile-container" ref="turnstile" :data-sitekey="cfSiteKey" :data-size="size"></div>
    </div>
</template>

<script>
export default {
    props: {
        token: {
            type: String,
            required: false,
        },
        size: {
            type: String,
            required: false,
            default: 'flexible',
        }
    },
    data() {
        return {
            cfSiteKey: '',
        }
    },
    mounted() {
        if (!this.token) {
            this.cfSiteKey = process.env.VUE_APP_CF_TURNSTILE_SITE_KEY;
        } else {
            this.cfSiteKey = this.token;
        }
        this.initTurnstile();
    },
    methods: {
        initTurnstile() {
            if (window.turnstile) {
                window.turnstile.render(this.$refs.turnstile, {
                    sitekey: this.cfSiteKey,
                    callback: (token) => {
                        this.$emit("verified", token);
                    },
                });
            } else {
                console.error("Turnstile script not loaded.");
            }
        },
    },
};
</script>
